import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoicingCapabilityQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InvoicingCapabilityQuery = { __typename?: 'Query', invoicingCapability: { __typename?: 'InvoicingCapability', can_act: boolean, owner_name?: string | null } };


export const InvoicingCapabilityDocument = gql`
    query InvoicingCapability {
  invoicingCapability {
    can_act
    owner_name
  }
}
    `;

/**
 * __useInvoicingCapabilityQuery__
 *
 * To run a query within a React component, call `useInvoicingCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicingCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicingCapabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvoicingCapabilityQuery(baseOptions?: Apollo.QueryHookOptions<InvoicingCapabilityQuery, InvoicingCapabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicingCapabilityQuery, InvoicingCapabilityQueryVariables>(InvoicingCapabilityDocument, options);
      }
export function useInvoicingCapabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicingCapabilityQuery, InvoicingCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicingCapabilityQuery, InvoicingCapabilityQueryVariables>(InvoicingCapabilityDocument, options);
        }
export type InvoicingCapabilityQueryHookResult = ReturnType<typeof useInvoicingCapabilityQuery>;
export type InvoicingCapabilityLazyQueryHookResult = ReturnType<typeof useInvoicingCapabilityLazyQuery>;
export type InvoicingCapabilityQueryResult = Apollo.QueryResult<InvoicingCapabilityQuery, InvoicingCapabilityQueryVariables>;